// Search terms map to the existing cuisine field's venue-type values.
export const CUISINE_KEYWORDS = {
 cocktail: ['cocktail bar'], cocktails: ['cocktail bar'], martini: ['cocktail bar'], mojito: ['cocktail bar'],
 dj: ['nightclub', 'dance club'], dance: ['nightclub', 'dance club'], dancing: ['nightclub', 'dance club'],
 beer: ['pub', 'brewery'], craft: ['brewery'], taproom: ['brewery'], wine: ['wine bar'],
 karaoke: ['karaoke bar'], hookah: ['hookah lounge'], rooftop: ['rooftop bar'],
 sports: ['sports bar'], football: ['sports bar'], music: ['live music'], jazz: ['live music', 'lounge'],
};
